import React from 'react'
import Loading from "../../components/common/Loading";
import switchStyles from "../../styles/desktopMobileSwitch.module.css";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";
import GiftShopParlor from '@/components/outlet/GiftShopParlor';

const giftShopParlor = () => {
  return (
    <>
      <Head>
        <title>Gift Shop Billing Software - Simple, Fast & Effective POS</title>
        <link rel="canonical" href="https://queuebuster.co/outlet/gift-shop-parlor" />
        <link rel="alternate" href="https://queuebuster.co/outlet/gift-shop-parlor" hrefLang="en-us" />
        <meta name="description" content="Manage your gift shop billing, inventory, and customer loyalty with QB's POS software. Enjoy fast billing, automated stock tracking, and seamless digital invoicing." />
        <meta property="og:title" content="Transform Your Gift Shop Billing with QB's Fast, Simple, and Efficient POS Software" />
        <meta property="og:description" content="QB Gift Shop Billing Software simplifies billing, inventory, and customer loyalty management. Enjoy ultra-fast billing, automated stock alerts, and seamless paperless invoicing. Perfect for boutiques or large gift stores—scale your business with ease!" />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/website/assets/OG+Images/OG%2BImages%2Bwebsite%2Bpages-04.jpg" />
        <meta property="og:url" content="https://queuebuster.co/outlet/gift-shop-parlor" />
      </Head>
         <SchemaTags page="gift-shop-parlor" />
      <GiftShopParlor />
    </>
  )
}

export default giftShopParlor